import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { UnsavedChangesGuard } from './core/guards/unsavedChanges.guard';

import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { GazeMapListComponent } from './pages/gaze-maps/gaze-map-list/gaze-map-list.component';
import { GazeMapActionsComponent } from './pages/gaze-maps/gaze-map-actions/gaze-map-actions.component';
import { FitListComponent } from './pages/fits/fit-list/fit-list.component';
import { FitErrorsComponent } from './pages/fits/fit-errors/fit-errors.component';
import { OrderListComponent } from './pages/made4u/orders/order-list/order-list.component';
import { OrderActionsComponent } from './pages/made4u/orders/order-actions/order-actions.component';
import { ScanListComponent } from './pages/made4u/scans/scan-list/scan-list.component';
import { ScanErrorsComponent } from './pages/made4u/scans/scan-errors/scan-errors.component';
import { SettingListComponent } from './pages/settings/setting-list/setting-list.component';
import { EntityListComponent } from './pages/entities/entity-list/entity-list.component';
import { EntityActionsComponent } from './pages/entities/entity-actions/entity-actions.component';
import { DeviceListComponent } from './pages/devices/device-list/device-list.component';
import { DeviceActionsComponent } from './pages/devices/device-actions/device-actions.component';
import { PackageListComponent } from './pages/licenses/package-list/package-list.component';
import { PackageActionsComponent } from './pages/licenses/package-actions/package-actions.component';
import { PackageTypeListComponent } from './pages/licenses/package-type-list/package-type-list.component';
import { PackageTypeActionsComponent } from './pages/licenses/package-type-actions/package-type-actions.component';
import { PolicyListComponent } from './pages/licenses/policy-list/policy-list.component';
import { PolicyActionsComponent } from './pages/licenses/policy-actions/policy-actions.component';
import { LoginComponent } from './pages/login/login.component';
import { UserListComponent } from './pages/users/user-list/user-list.component';
import { UserActionsComponent } from './pages/users/user-actions/user-actions.component';
import { HorizonsTeamListComponent } from './pages/users/horizons-team-list/horizons-team-list.component';
import { HorizonsTeamActionsComponent } from './pages/users/horizons-team-actions/horizons-team-actions.component';
import { TeamListComponent } from './pages/users/team-list/team-list.component';
import { TeamActionsComponent } from './pages/users/team-actions/team-actions.component';
import { AnalyticsPackagesComponent } from './pages/analytics/analytics-packages/analytics-packages.component';
import { AnalyticsVrresultsComponent } from './pages/analytics/analytics-vrresults/analytics-vrresults.component';
import { AnalyticsFitComponent } from './pages/analytics/analytics-fit/analytics-fit.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [authGuard]
  },
  {
    path: 'set-password.html',
    redirectTo: 'set-password'
  },
  {
    path: 'set-password',
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard]
  },
  {
    path: 'gaze-maps',
    component: GazeMapListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'gaze-maps/:testId',
    component: GazeMapActionsComponent,
    canActivate: [authGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'fits',
    component: FitListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'fits/errors',
    component: FitErrorsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'orders',
    component: OrderListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'orders/:action',
    component: OrderActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'scanns',
    component: ScanListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'scanns/errors',
    component: ScanErrorsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'settings/:application',
    component: SettingListComponent,
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    component: SettingListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'entities',
    component: EntityListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'entities/:action',
    component: EntityActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'devices',
    component: DeviceListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'devices/:action',
    component: DeviceActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'licenses/packages',
    component: PackageListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'licenses/packages/:action',
    component: PackageActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'licenses/packages/:action/:id',
    pathMatch: 'full',
    component: PackageActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'licenses/package-types',
    component: PackageTypeListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'licenses/package-types/:action',
    component: PackageTypeActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'licenses/policies',
    component: PolicyListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'licenses/policies/:action',
    component: PolicyActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'users',
    component: UserListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'users/horizonsteams',
    component: HorizonsTeamListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'users/horizonsteams/:action',
    component: HorizonsTeamActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'users/teams',
    component: TeamListComponent,
    canActivate: [authGuard]
  },
  {
    path: 'users/teams/:action',
    component: TeamActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'user/settings',
    component: UserActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'admin-tools',
    loadChildren: () => import('./shared/admin/admin/admin.module').then(m => m.AdminModule),
    canActivate: [authGuard]
  },
  {
    path: 'users/:action',
    component: UserActionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'entities',
    component: PageNotFoundComponent,
  },
  {
    path: 'analytics',
    component: AnalyticsPackagesComponent,
    canActivate: [authGuard]
  },
  {
    path: 'analytics/vrresults',
    component: AnalyticsVrresultsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'analytics/fit',
    component: AnalyticsFitComponent,
    canActivate: [authGuard]
  },
  {
    path: 'analytics/packages',
    component: AnalyticsPackagesComponent,
    canActivate: [authGuard]
  },
  {
    path: '**',
    redirectTo: 'entities'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
